import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

/**
 * Reusable submitter for public forms.
 * kind: one of contact|volunteer|partnership|sponsor|community_support|skills_registration|newsletter|donation_confirmation|media_enquiry
 */
export function useFormSubmit(kind) {
    const [submitting, setSubmitting] = useState(false);
    const [done, setDone] = useState(false);
    const [error, setError] = useState("");

    async function submit(fields, consent) {
        if (!consent) {
            setError("Please provide consent to submit this form.");
            toast.error("Consent required");
            return false;
        }
        setSubmitting(true);
        setError("");
        try {
            const { data } = await api.post("/forms/submit", { kind, fields, consent });
            setDone(true);
            toast.success("Thank you — your submission has been received.");
            return data;
        } catch (e) {
            const msg = formatApiError(e);
            setError(msg);
            toast.error(msg);
            return false;
        } finally {
            setSubmitting(false);
        }
    }

    return { submit, submitting, done, error, setDone };
}
